/**
 @ngdoc directive
 @name dynamicQueryString

 @description
 Dynamically updates query string with given property after compilation whilst maintaining checksums

 @usage
 <a dynamic-query-string="new-param='new-value'" ></a>

 */

(function () {
  "use strict";
  var dynamicLocationDirective = function () {
    return {          
      restrict: "A",
      controllerAs: "ctrl",
      scope: {
        dynamicLocation: "@",
      },
      link: function ($scope, $element) {
        
        $scope.$watch('dynamicLocation', function() {
            const url = new URL($element[0].href);
            url.hash = $scope.dynamicLocation
            $element[0].href = url;
        })
      },
    };
  };
  angular
    .module("app")
    .directive("dynamicLocation", dynamicLocationDirective);
})();
  